import log from '~/utils/log';
import {
    onConsentUpdated,
    refreshUsercentricsConsentCache,
    useUsercentricsConsentItem
} from '~/utils/manageUsercentricsConsent';

export default defineNuxtPlugin((nuxtApp) => {
    const questionProConsent = useUsercentricsConsentItem('question_pro');
    let hadQuestionProConsent = false;

    // mitigating potential bug, where onConsentUpdated() is not being
    // called when acceptUsercentricsConsent() is called.
    const stopWatch = watch(questionProConsent, (newVal, oldVal) => {
        if (oldVal !== newVal) {
            applyConsent();
        }
    });

    const applyConsent = () => {
        const hasQuestionProConsent = questionProConsent.value === true;
        const consentRevoked = hadQuestionProConsent && !hasQuestionProConsent;

        // The watcher above and onConsentUpdated() both react to the same consent change, so this can
        // run twice per change. Updating the flag before reloading keeps the second run a no-op.
        hadQuestionProConsent = hasQuestionProConsent;

        if (consentRevoked) {
            window.location.reload();
        }
    };

    refreshUsercentricsConsentCache()
        .then(applyConsent)
        .catch((error) => {
            log.warn('Failed to refresh Usercentrics consent state', error);
        });

    const unsubscribe = onConsentUpdated(applyConsent);

    nuxtApp.hook('vue:setup', () => {
        onBeforeUnmount(() => {
            unsubscribe();
            stopWatch();
        });
    });
});
